import React from "react";
import { Grid, Layout } from 'antd';
import { CustomSider } from "components/layout/sider";
import { RefineThemedLayoutV2Props, ThemedLayoutContextProvider } from "@refinedev/antd";
import { isSupplierOnly } from "utility/helper";

export const CustomLayout: React.FC<RefineThemedLayoutV2Props> = ({
    children,
    Header,
    OffLayoutArea,
    initialSiderCollapsed,
}) => {
  
  const breakpoint = Grid.useBreakpoint();
  const isSmall = typeof breakpoint.sm === "undefined" ? true : breakpoint.sm;
  const { Content } = Layout;
  const Ele = () => <></>;
  const HeaderToRender : React.FC = Header ?? Ele;
  const hideSider = isSupplierOnly();

  return (
    <ThemedLayoutContextProvider initialSiderCollapsed={initialSiderCollapsed}>
      <Layout
        style={{ minHeight: "80vh", display: "flex", flexDirection: "column" }}
      >
        <HeaderToRender/>
        <Layout>
          {!hideSider && <CustomSider></CustomSider>}
          <Layout style={{ padding: "0 24px 24px", backgroundColor: '#ededed' }}>
          <Content>
            <div
                style={{
                    minHeight: 360,
                    padding: isSmall ? 24 : 12,
                }}
            >
                {children}
            </div>
            {OffLayoutArea && <OffLayoutArea />}
          </Content>
          </Layout>
        </Layout>
      </Layout>
    </ThemedLayoutContextProvider>
  );
};